"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _axios = _interopRequireDefault(require("axios"));

var _useGlobalState = require("../useGlobalState");

var _sharedRequest = require("./sharedRequest");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useAsyncRequest = function useAsyncRequest(_a) {
  var method = _a.method,
      path = _a.path,
      params = _a.params,
      headers = _a.headers;
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    var devPrefix, url, additionalHeaders, axiosOptions, res;
    return (0, _tslib.__generator)(this, function (_b) {
      switch (_b.label) {
        case 0:
          devPrefix = (0, _useGlobalState.useGlobalState)('apiLocation', true)[0];
          url = devPrefix ? "" + devPrefix + path : path;
          additionalHeaders = headers ? (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _sharedRequest.baseHeaders)(true)), headers) : (0, _tslib.__assign)({}, (0, _sharedRequest.baseHeaders)(true));
          axiosOptions = {
            method: method,
            url: url,
            headers: additionalHeaders
          };

          if ((0, _sharedRequest.hasParams)(method)) {
            axiosOptions.params = params;
          }

          if ((0, _sharedRequest.hasData)(method)) {
            axiosOptions.data = params;
          }

          res = {
            data: undefined,
            isLoading: true,
            isErrored: false,
            exception: undefined
          };
          return [4
          /*yield*/
          , (0, _axios["default"])((0, _tslib.__assign)({}, axiosOptions)).then(function (result) {
            res = (0, _tslib.__assign)((0, _tslib.__assign)({}, res), {
              data: result.data,
              isLoading: false
            });
          })["catch"](function (exception) {
            res = (0, _tslib.__assign)((0, _tslib.__assign)({}, res), {
              isLoading: false,
              isErrored: true,
              exception: exception
            });
          })];

        case 1:
          _b.sent();

          return [2
          /*return*/
          , res];
      }
    });
  });
};

var _default = useAsyncRequest;
exports["default"] = _default;